/* eslint-disable import/no-named-as-default */
import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { Helmet } from "react-helmet-async";

import Menu from "./Menu";
import CatalogFooter from "./Footer-new";
import CatalogFooter2 from "./Footer2";
import ServiceHealthBar from "./ServiceHealthBar";
import RTL from "./RTL";

const styles = {
  spacer: {
    height: 40,
  },
  "@media (min-width: 1024px)": {
    spacer: {
      height: 82,
    },
  },
};

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      clickCount: 0,
      clickTimeout: null,
    };
    this.handleSecretAdminAccess = this.handleSecretAdminAccess.bind(this);
  }

  handleSecretAdminAccess = () => {
    this.setState((prevState) => ({
      clickCount: prevState.clickCount + 1,
    }));

    // Clear any existing timeout
    if (this.state.clickTimeout) {
      clearTimeout(this.state.clickTimeout);
    }

    // Set a new timeout to reset click count after 2 seconds
    const timeout = setTimeout(() => {
      this.setState({ clickCount: 0, clickTimeout: null });
    }, 2000);

    this.setState({ clickTimeout: timeout });

    // If this is the third click, redirect to admin
    if (this.state.clickCount >= 2) {
      // 2 because we just incremented
      this.setState({ clickCount: 0, clickTimeout: null });
      if (this.state.clickTimeout) {
        clearTimeout(this.state.clickTimeout);
      }

      // Navigate to admin panel
      if (typeof window !== "undefined") {
        window.location.href = "/admin";
      }
    }
  };

  componentDidMount() {
    // Load limited time offers when app mounts (client-side only)
    if (this.props.actions && this.props.actions.getLimitedTimeOffers) {
      this.props.actions.getLimitedTimeOffers();
    }
  }

  componentWillUnmount() {
    if (this.state.clickTimeout) {
      clearTimeout(this.state.clickTimeout);
    }
  }

  render() {
    const { classes } = this.props;

    const baseDescription =
      "צמיגים לאופנועים מהיבואן לצרכן עד 70% הנחה כולל תור בקליק במוסכים מקצועיים ברחבי הארץ שירות אדיב ומלאי ענקי";

    return (
      <RTL>
        <div style={{ paddingBottom: 100 }}>
          <Menu actions={this.props.actions} catalog={this.props.catalog} />
          <Helmet>
            <meta charSet="utf-8" />
            <meta name="Content-language" content="he" />
            <meta
              property="og:title"
              content="צמיגים לאופנועים | ספורטישופ | מהיבואן לצרכן | פירלי | מישלין | מצלר | קונטיננטל | דנלופ"
            />
            <meta
              property="og:image"
              content="https://s3.eu-west-2.amazonaws.com/sportyshop/catalog/homepage/covers/cover.jpeg"
            />
            <meta property="og:site_name" content="ספורטישופ יבוא צמיגים" />
            <meta property="og:description" content={baseDescription} />
            <meta property="description" content={baseDescription} />

            <title>צמיגים לאופנועים | ספורטישופ | מהיבואן לצרכן</title>
          </Helmet>

          <div className={classes.spacer}></div>

          {this.props.children}
          <CatalogFooter />
          <CatalogFooter2 />
          <ServiceHealthBar />

          {/* Secret admin access trigger */}
          <div style={{ textAlign: "center", marginTop: 12, padding: 16 }}>
            <Typography
              variant="body2"
              style={{
                color: "#888",
                cursor: "default",
                userSelect: "none",
                fontSize: "0.75rem",
              }}
              onClick={this.handleSecretAdminAccess}
            >
              © 2026 SportyShop. כל הזכויות שמורות.
            </Typography>
          </div>
        </div>
      </RTL>
    );
  }
}

App.propTypes = {
  children: PropTypes.element,
  jsses: PropTypes.object,
  actions: PropTypes.object,
  catalog: PropTypes.object,
};

export default withStyles(styles)(App);
